import { Image, Container, Row, Col } from 'react-bootstrap';
// import Img from '../Img/Story/Banner-2.png';
import Img from '../Img/Why Us/Why Us Banner.jpg';
import CS from '../Img/Story/Comming Soon.jpeg';
// import Expo from '../Img/Story/Expo.png';
import "./Services.css";

function OurStory() {
    return (
        <>
            <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />
            <Container>
                            <Row>
                                <Col>
                                    <h1 className='text-center mt-4 text-decoration-underline'><strong>Trade Show / Exhibition</strong></h1>
                                    <p className='justify-text' style={{ fontSize: '20px' }}> India has emerged as a trusted sourcing partner for the global market, and the Indian Fair serves as a key facilitator—providing a comprehensive, one-stop sourcing destination for buyers from around the world.</p>
                                    <p className='justify-text' style={{ fontSize: '20px' }}> The event offers overseas buyers valuable opportunities to develop exclusive products, understand market requirements and trends, and collaborate on export orders tailored to their needs.</p>
                                    <p className='justify-text' style={{ fontSize: '20px' }}> With its strong visitor profile and significant buying power, the fair enhances opportunities for businesses to build relationships, secure new orders, and expand their network. Many attendees come specifically to discover new products and reliable suppliers, making the fair an ideal platform for meaningful business growth.</p>

                                    {/* <p className='justify-text' style={{ fontSize: '20px' }}> <strong>Best Regards</strong> </p> */}

                                    <Image src={CS} className='my-5' alt="Expo" width="100%" height={550}/>
                                    {/* <p className='text-center' style={{ fontSize: '20px' }}>
                            <strong>Bhadohi: The Carpet City of India – Weaving Tradition, Trade, and Textiles </strong> <br />
                             Nestled in the eastern part of Uttar Pradesh, Bhadohi—often hailed as the "Carpet City of India"—is a vibrant hub where ancient weaving artistry meets modern global commerce. Just 45 kilometers from the historic city of Varanasi.</p> */}
                                </Col>
                            </Row>
                        </Container>
            {/* <Container>
                <Row className='py-5'>
                    <Col md={6} className='gx-5'>
                        <h1 className="mb-4">India Carpet Expo</h1>
                        <p className='justify-text' style={{ fontSize: '20px' }}>
                            <strong>Trade Shows: Bhadohi's Global Stage for Weavers and Buyers </strong> 
                            <br />
                             Bhadohi's trade shows are the heartbeat of its industry, transforming the town into a bustling marketplace twice a year. The flagship event, the India Carpet Expo (ICE), is Asia's largest Handmade Carpet Fair. it has evolved into a biannual spectacle that highlights Bhadohi's "Town of Excellence" status.
                        </p>
                        
                    </Col>

                    <Col md={6} className='gx-5'>
                    <Image src={Expo} alt="Expo" width="100%" height={550}/>
                    </Col>
                </Row>
            </Container> */}
        </>
    )
}

export default OurStory